import VPricingDetailBaseItem from './VPricingDetailBaseItem';
import mathHelper from '../Helpers/mathHelper';
import PricingDetailAdmin from '../Contents/Sales/PricingDetail/PricingDetailAdmin';
import moneyHelper from '../Helpers/moneyHelper';

class TierItemList {
  constructor(item, pricingDetails) {
    if (item === undefined) {
      this.PanelMgrRecruiterDailyCostOfficeOverrideCur = 0;
      this.NumEvalsPerCycle = 0;
      this.NumEvalsAnnually = 0;
      this.ClientRevenueTotal = 0;
      this.ClientFeePerCycleTotal = 0;
      this.ClientFeePctTotal = 0;
      this.TravelCostAnnuallyTotal = 0;
      this.MarkedUpRevenuePerCycleTotal = 0;
      this.TierList = [];
      this.PricingDetails = new VPricingDetailBaseItem();
    } else {
      this.TierList = item;
      this.PricingDetails = pricingDetails;
      this.NumEvalsPerCycle = 0;
      this.NumEvalsAnnually = 0;
      this.ClientRevenueTotal = 0;
      this.ClientFeePerCycleTotal = 0;
      this.ClientFeePctTotal = 0;
      this.TravelCostAnnuallyTotal = 0;
      this.MarkedUpRevenuePerCycleTotal = 0;
      this.CurrencySymbol = pricingDetails.CurrencySymbol;
      this.PanelMgrRecruiterDailyCostOfficeOverrideCur = 0;

      this.Calculate();
    }
    this.Calculate = this.Calculate.bind(this);
    this.AddPricingDetailValues(pricingDetails);
  }

  AddPricingDetailValues(pricingDetails) {
    this.TierList.forEach((t) => {
      t.CurrencySymbol = pricingDetails.CurrencySymbol;
    });
  }

  Calculate() {
    let NumEvalsPerCycle = 0;
    let ClientRevenueTotal = 0;
    let ClientFeePerCycleTotal = 0;
    let ClientFeePctTotal = 0;
    let TravelCostAnnuallyTotal = 0;
    let MarkedUpRevenuePerCycleTotal = 0;
    let MarkedUpAnnuallyTotal = 0;
    let RevenuePerCircleTotal = 0;

    this.TierList.forEach((t) => {
      if (this.validate(t.NumEvalsPerCycle)) NumEvalsPerCycle += parseFloat(t.NumEvalsPerCycle);

      if (this.validate(t.ClientFeeAnnually)) ClientRevenueTotal += parseFloat(t.ClientFeeAnnually);

      if (this.validate(t.ClientFeePerCycle)) ClientFeePerCycleTotal += parseFloat(t.ClientFeePerCycle);

      if (this.validate(t.MarkedUpFeePerCycle)) MarkedUpRevenuePerCycleTotal += parseFloat(t.MarkedUpFeePerCycle);

      if (this.validate(t.MarkedUpAnnually)) MarkedUpAnnuallyTotal += parseFloat(t.MarkedUpAnnually);

      if (this.validate(t.TravelCostAnnually)) TravelCostAnnuallyTotal += parseFloat(t.TravelCostAnnually);

      if (this.validate(t.EvalFeeAnnually)) RevenuePerCircleTotal += parseFloat(t.EvalFeeAnnually);
    });

    this.NumEvalsPerCycle = NumEvalsPerCycle;
    this.ClientRevenueTotal = ClientRevenueTotal;
    this.ClientFeePerCycleTotal = ClientFeePerCycleTotal;

    this.TravelCostAnnuallyTotal = TravelCostAnnuallyTotal;
    this.MarkedUpRevenuePerCycleTotal = MarkedUpRevenuePerCycleTotal;
    this.MarkedUpRevenueTotal = MarkedUpAnnuallyTotal;

    this.NumEvalsAnnually = NumEvalsPerCycle * this.PricingDetails.NumCyclesPerYr;
    //Changed in CD-3973
    //this.MarkedUpRevenueTotalPct = `${(this.MarkedUpRevenueTotal / ClientRevenueTotal - 1) * 100}  %`;
    this.MarkedUpRevenueTotalPct = mathHelper.SimplePercentageTextTwoDecimal(
      (this.MarkedUpRevenueTotal / ClientRevenueTotal - 1) * 100
    );

    this.PricingDetails.EvalBonusAnnually = this.PricingDetails.EvalBonusPerCycle * this.PricingDetails.NumCyclesPerYr;
    this.PricingDetails.BankChargesAnnually =
      this.PricingDetails.BankChargesPerCycle * this.PricingDetails.NumCyclesPerYr;

    this.EvalFeeAnnually =
      this.PricingDetails.EvalBonusAnnually + this.PricingDetails.BankChargesAnnually + RevenuePerCircleTotal;

    this.TierList.forEach((t) => {
      t.EachTierPrecentage = mathHelper.PercentageTextTwoDecimal(t.NumEvalsPerYear, this.NumEvalsAnnually);
      t.ClientFeePct = mathHelper.PercentageTextTwoDecimal(t.ClientFeeAnnually, this.ClientRevenueTotal);
      t.CurrencyCode = this.PricingDetails.CurrencyCode;
    });

    this.TierList.forEach((t) => {
      if (t.ClientFeePct !== null && t.ClientFeePct !== `0.00 %`) ClientFeePctTotal += parseFloat(t.ClientFeePct);
    });

    this.PricingDetails.BankChargesPct = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.BankChargesAnnually,
      this.EvalFeeAnnually
    );
    this.PricingDetails.EvalBonusPct = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.EvalBonusAnnually,
      this.EvalFeeAnnually
    );

    this.ClientFeePctTotal = mathHelper.SimplePercentageTextTwoDecimal(ClientFeePctTotal);

    this.EvalCostPct = mathHelper.PercentageTextTwoDecimal(this.EvalFeeAnnually, this.MarkedUpRevenueTotal);

    this.TravelCostpct = mathHelper.PercentageTextTwoDecimal(this.TravelCostAnnuallyTotal, this.MarkedUpRevenueTotal);

    //Other misc costs (if applicable)

    this.PricingDetails.PctMiscCost1 = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.AnnualRecruitingCost,
      this.MarkedUpRevenueTotal
    );
    this.PricingDetails.PctMiscCost2 = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.AnnualCallsToShopperCost,
      this.MarkedUpRevenueTotal
    );
    this.PricingDetails.PctMiscCost3 = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.AnnualMiscCost3,
      this.MarkedUpRevenueTotal
    );

    this.PricingDetails.AnnualMiscCostPerCycle1 =
      this.PricingDetails.MiscCostPerCycle1 * this.PricingDetails.NumCyclesPerYr;
    this.PricingDetails.AnnualMiscCostPerCycle2 =
      this.PricingDetails.MiscCostPerCycle2 * this.PricingDetails.NumCyclesPerYr;
    this.PricingDetails.AnnualMiscCostPerCycle3 =
      this.PricingDetails.MiscCostPerCycle3 * this.PricingDetails.NumCyclesPerYr;

    this.PricingDetails.PctMiscCostPerCycle1 = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.AnnualMiscCostPerCycle1,
      this.MarkedUpRevenueTotal
    );
    this.PricingDetails.PctMiscCostPerCycle2 = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.AnnualMiscCostPerCycle2,
      this.MarkedUpRevenueTotal
    );
    this.PricingDetails.PctMiscCostPerCycle3 = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.AnnualMiscCostPerCycle3,
      this.MarkedUpRevenueTotal
    );

    this.RecruitingCostTotal =
      parseFloat(this.PricingDetails.AnnualRecruitingCost) +
      parseFloat(this.PricingDetails.AnnualCallsToShopperCost) +
      parseFloat(this.PricingDetails.AnnualMiscCost3) +
      parseFloat(this.PricingDetails.AnnualMiscCostPerCycle1) +
      parseFloat(this.PricingDetails.AnnualMiscCostPerCycle2) +
      parseFloat(this.PricingDetails.AnnualMiscCostPerCycle3);
    this.RecruitingCostPct = mathHelper.PercentageTextTwoDecimal(this.RecruitingCostTotal, this.MarkedUpRevenueTotal);

    //Editing cost
    this.PricingDetails.EditorCostPerCycle = this.PricingDetails.EditorCostPerEval * this.NumEvalsPerCycle;
    this.PricingDetails.EditorCostAnnually =
      this.PricingDetails.EditorCostPerCycle * this.PricingDetails.NumCyclesPerYr;
    this.PricingDetails.EditorCostPct = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.EditorCostAnnually,
      this.MarkedUpRevenueTotal
    );

    this.PricingDetails.TransCostPerCycle = this.PricingDetails.TransCostPerEval * this.NumEvalsPerCycle;
    this.PricingDetails.TransCostAnnually = this.PricingDetails.TransCostPerCycle * this.PricingDetails.NumCyclesPerYr;
    this.PricingDetails.TransCostPct = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.TransCostAnnually,
      this.MarkedUpRevenueTotal
    );

    this.PricingDetails.ExtDataCheckPerCycle = this.PricingDetails.ExtDataCheckPerEval * this.NumEvalsPerCycle;
    this.PricingDetails.ExtDataCheckAnnually =
      this.PricingDetails.ExtDataCheckPerCycle * this.PricingDetails.NumCyclesPerYr;
    this.PricingDetails.ExtDataCheckPct = mathHelper.PercentageTextTwoDecimal(
      this.PricingDetails.ExtDataCheckAnnually,
      this.MarkedUpRevenueTotal
    );

    this.EditingCostTotal =
      this.PricingDetails.EditorCostAnnually +
      this.PricingDetails.TransCostAnnually +
      this.PricingDetails.ExtDataCheckAnnually;
    this.EditingCostPct = mathHelper.PercentageTextTwoDecimal(this.EditingCostTotal, this.MarkedUpRevenueTotal);

    //--Employee cost---
    const _currencyRate =
      this.PricingDetails.StatusCode === 2 ? this.PricingDetails.FinalizedRate : this.PricingDetails.CurrencyRate;

    //TeamLeadDailyCostOverrideCur,ProjMgrDailyCostOverrideCur,OperationsMgrDailyCostOverrideCur,
    //AssistantProjMgrDailyCostOverrideCur, PanelMgrRecruiterDailyCostOverrideCur, EditDataCheckDailyCostOverrideCur
    const costTypes = [
      'TeamLead',
      'ProjMgr',
      'OperationsMgr',
      'AssistantProjMgr',
      'PanelMgrRecruiter',
      'EditDataCheck',
    ];
    costTypes.forEach((costType) => {
      //Changed Override logic in CD-3973 to work similarly to CD-3930 Platform Cost override
      if (
        this.PricingDetails[`${costType}DailyCostOverrideCur`] === undefined ||
        !this.PricingDetails[`${costType}DailyCostOverride`]
      ) {
        this.PricingDetails[`${costType}DailyCostOverrideCur`] =
          this.PricingDetails[`${costType}DailyCostOverride`] || this.StatusCode === 2
            ? parseFloat(this.PricingDetails[`${costType}DailyCost`] * _currencyRate)
            : parseFloat(this.PricingDetails[`${costType}DailyCostOffice`] * _currencyRate);
      }

      this.PricingDetails[`${costType}SalaryPerCycle`] =
        this.PricingDetails[`${costType}DaysPerCycle`] * this.PricingDetails[`${costType}DailyCost`];

      this.PricingDetails[`${costType}SalaryAnnually`] =
        this.PricingDetails[`${costType}SalaryPerCycle`] * this.PricingDetails.NumCyclesPerYr;

      this.PricingDetails[`${costType}SalaryPct`] = mathHelper.PercentageTextTwoDecimal(
        this.PricingDetails[`${costType}SalaryAnnually`] * _currencyRate,
        this.MarkedUpRevenueTotal
      );
    });

    //Total # of mandays per client cycle
    this.DaysPerCycleTotal =
      parseFloat(this.PricingDetails.EditDataCheckDaysPerCycle) +
      parseFloat(this.PricingDetails.PanelMgrRecruiterDaysPerCycle) +
      parseFloat(this.PricingDetails.AssistantProjMgrDaysPerCycle) +
      parseFloat(this.PricingDetails.OperationsMgrDaysPerCycle) +
      parseFloat(this.PricingDetails.ProjMgrDaysPerCycle) +
      parseFloat(this.PricingDetails.TeamLeadDaysPerCycle);

    //SUB EMPLOYEE COST
    this.EmployeeCostPerCycle =
      (this.PricingDetails.EditDataCheckSalaryPerCycle +
        this.PricingDetails.PanelMgrRecruiterSalaryPerCycle +
        this.PricingDetails.AssistantProjMgrSalaryPerCycle +
        this.PricingDetails.OperationsMgrSalaryPerCycle +
        this.PricingDetails.ProjMgrSalaryPerCycle +
        this.PricingDetails.TeamLeadSalaryPerCycle) *
      _currencyRate;

    this.EmployeeCostSubTotal =
      (this.PricingDetails.TeamLeadSalaryAnnually +
        this.PricingDetails.ProjMgrSalaryAnnually +
        this.PricingDetails.OperationsMgrSalaryAnnually +
        this.PricingDetails.AssistantProjMgrSalaryAnnually +
        this.PricingDetails.PanelMgrRecruiterSalaryAnnually +
        this.PricingDetails.EditDataCheckSalaryAnnually) *
      _currencyRate;

    this.EmployeeCostSubPct = mathHelper.PercentageTextTwoDecimal(this.EmployeeCostSubTotal, this.MarkedUpRevenueTotal);

    //Payroll tax (if applicable)
    this.PayrollTaxPct = mathHelper.SimplePercentageTextTwoDecimal(this.PricingDetails.PayrollTaxPct);
    this.PayrollTaxPctConv = this.PricingDetails.PayrollTaxPct / 100;
    this.PayrollTaxPerCycle = parseFloat(this.PayrollTaxPctConv * this.EmployeeCostPerCycle);
    this.PayrollTaxAnnually = parseFloat(this.PayrollTaxPctConv * this.EmployeeCostSubTotal);
    this.PayrollTaxTotalPct = mathHelper.PercentageTextTwoDecimal(this.PayrollTaxAnnually, this.MarkedUpRevenueTotal);

    //Employee benefits cost
    this.EmpBenefitsDailyCost = mathHelper.SimplePercentageTextTwoDecimal(this.PricingDetails.EmpBenefitsDailyCost);
    this.EmpBenefitsDailyCostConv = this.PricingDetails.EmpBenefitsDailyCost / 100;
    this.EmpBenefitsPerCycle = parseFloat(this.EmpBenefitsDailyCostConv * this.EmployeeCostPerCycle);
    this.EmpBenefitsAnnually = parseFloat(this.EmpBenefitsPerCycle * this.PricingDetails.NumCyclesPerYr);
    this.EmpBenefitsPct = mathHelper.PercentageTextTwoDecimal(this.EmpBenefitsAnnually, this.MarkedUpRevenueTotal);

    //Commission
    this.CommissionPct = mathHelper.SimplePercentageTextTwoDecimal(this.PricingDetails.CommissionPct);
    const CommissionPctConv = this.PricingDetails.CommissionPct / 100;
    this.CommissionPerCycle = parseFloat(MarkedUpRevenuePerCycleTotal * CommissionPctConv);
    this.CommissionAnnually = parseFloat(this.CommissionPerCycle * this.PricingDetails.NumCyclesPerYr);
    this.CommissionTotalPct = mathHelper.PercentageTextTwoDecimal(this.CommissionAnnually, this.MarkedUpRevenueTotal);

    this.EmployeeCostTotal =
      this.CommissionAnnually + this.EmpBenefitsAnnually + this.PayrollTaxAnnually + this.EmployeeCostSubTotal;
    this.EmployeeCostPct = mathHelper.PercentageTextTwoDecimal(this.EmployeeCostTotal, this.MarkedUpRevenueTotal);

    //8. OTHER DIRECT COSTS
    //Surf Merchants Cost

    //Added in CD-3930
    //If SM Cost is not overridden, the original value is used for the Per Eval calculation, and the value is reset
    if (this.PricingDetails.SMCostPerEvalOverride !== true) {
      this.PricingDetails.SMCostPerEval = this.PricingDetails.SMCostPerEvalOrig;
    }

    this.SMCostPerEvalConv = parseFloat(this.PricingDetails.SMCostPerEval * _currencyRate);
    this.SMCostPerCycle = parseFloat(this.SMCostPerEvalConv * this.NumEvalsPerCycle);
    this.SMCostAnnually = parseFloat(
      this.SMCostPerEvalConv * this.NumEvalsPerCycle * this.PricingDetails.NumCyclesPerYr
    );
    this.SMCostPct = mathHelper.PercentageTextTwoDecimal(this.SMCostAnnually, this.MarkedUpRevenueTotal);

    //Vocazilla Cost
    this.VocazillaCostPerEvalConv = parseFloat(this.PricingDetails.VocazillaCostPerEval * _currencyRate); //Added multiplication by currencyRate in CD-4010
    this.VocazillaCostPerCycle = parseFloat(this.VocazillaCostPerEvalConv * this.NumEvalsPerCycle);
    this.VocazillaCostAnnually = parseFloat(this.VocazillaCostPerCycle * this.PricingDetails.NumCyclesPerYr);
    this.VocazillaCostPct = mathHelper.PercentageTextTwoDecimal(this.VocazillaCostAnnually, this.MarkedUpRevenueTotal);

    this.IVRFeeCostPerEvalConv = parseFloat(this.PricingDetails.IvrfeeCostPerEval * _currencyRate); //Added multiplication by currencyRate in CD-4010
    this.IVRFeeCostPerCycle = parseFloat(this.IVRFeeCostPerEvalConv * this.NumEvalsPerCycle) || 0;
    this.IVRFeeCostAnnually = parseFloat(this.IVRFeeCostPerCycle * this.PricingDetails.NumCyclesPerYr);
    this.IVRFeeCostPct = mathHelper.PercentageTextTwoDecimal(this.IVRFeeCostAnnually, this.MarkedUpRevenueTotal);

    //ICR Cost
    this.ICRFeeCostPerEvalConv = parseFloat(this.PricingDetails.IcrfeeCostPerEval * _currencyRate); //Added multiplication by currencyRate in CD-4010
    this.ICRFeeCostPerCycle = parseFloat(this.ICRFeeCostPerEvalConv * this.NumEvalsPerCycle) || 0;
    this.ICRFeeCostAnnually = parseFloat(this.ICRFeeCostPerCycle * this.PricingDetails.NumCyclesPerYr);
    this.ICRFeeCostPct = mathHelper.PercentageTextTwoDecimal(this.ICRFeeCostAnnually, this.MarkedUpRevenueTotal);

    //Overhead Rate (12 mo avg)
    this.OverheadRatePct = mathHelper.SimplePercentageTextTwoDecimal(this.PricingDetails.OverheadRatePct);
    this.OverheadRatePctConv = this.PricingDetails.OverheadRatePct / 100;
    this.OverheadRateAnnually = parseFloat(this.OverheadRatePctConv * this.ClientRevenueTotal);
    this.OverheadRateCostPct = mathHelper.PercentageTextTwoDecimal(
      this.OverheadRateAnnually,
      this.MarkedUpRevenueTotal
    );

    //TOTAL OTHER COST
    this.OtherCostTotal = 0;
    if (this.OverheadRateAnnually >= 0) this.OtherCostTotal += this.OverheadRateAnnually;

    if (this.ICRFeeCostAnnually >= 0) this.OtherCostTotal += this.ICRFeeCostAnnually;

    if (this.IVRFeeCostAnnually >= 0) this.OtherCostTotal += this.IVRFeeCostAnnually;

    if (this.VocazillaCostAnnually >= 0) this.OtherCostTotal += this.VocazillaCostAnnually;

    if (this.SMCostAnnually >= 0) this.OtherCostTotal += this.SMCostAnnually;

    this.OtherCostTotal = parseFloat(this.OtherCostTotal);
    this.OtherCostPct = mathHelper.PercentageTextTwoDecimal(this.OtherCostTotal, this.MarkedUpRevenueTotal);

    //9. VIDEO  COSTS (IF APPLICABLE)
    //Editor
    this.EditorCostPerHour = mathHelper.SimplePercentageTextTwoDecimal(this.PricingDetails.EditorCostPerHour);
    this.EditorCostPerHourConv = this.PricingDetails.EditorCostPerHour;
    this.VideoEditorCostPerEval = parseFloat(this.EditorCostPerHourConv * this.PricingDetails.LengthVideoShopHours);
    this.VideoEditorCostPerCycle = parseFloat(this.VideoEditorCostPerEval * this.NumEvalsPerCycle);
    this.VideoEditorCostAnnually = parseFloat(this.VideoEditorCostPerCycle * this.PricingDetails.NumCyclesPerYr) || 0;
    this.VideoEditorCostPct = mathHelper.PercentageTextTwoDecimal(
      this.VideoEditorCostAnnually,
      this.MarkedUpRevenueTotal
    );

    //Time Capture
    this.TimeCaptureCostPerHour = mathHelper.SimplePercentageTextTwoDecimal(this.PricingDetails.TimeCaptureCostPerHour);
    this.TimeCaptureCostPerHourConv = this.PricingDetails.TimeCaptureCostPerHour;
    this.TimeCaptureCostPerEval = parseFloat(
      this.TimeCaptureCostPerHourConv * this.PricingDetails.LengthVideoShopHours
    );
    this.TimeCaptureCostPerCycle = parseFloat(this.TimeCaptureCostPerEval * this.NumEvalsPerCycle);
    this.TimeCaptureCostAnnually = parseFloat(this.TimeCaptureCostPerCycle * this.PricingDetails.NumCyclesPerYr) || 0;
    this.TimeCaptureCostPct = mathHelper.PercentageTextTwoDecimal(
      this.TimeCaptureCostAnnually,
      this.MarkedUpRevenueTotal
    );

    //Shipping/Handling
    this.ShippingCostPerEvalConv = this.PricingDetails.ShippingCostPerEval;
    this.ShippingCostPerCycle =
      this.PricingDetails.LengthVideoShopHours > 0
        ? parseFloat(this.ShippingCostPerEvalConv * this.NumEvalsPerCycle)
        : 0;
    this.ShippingCostAnnually = parseFloat(this.ShippingCostPerCycle * this.PricingDetails.NumCyclesPerYr) || 0;
    this.ShippingCostPct = mathHelper.PercentageTextTwoDecimal(this.ShippingCostAnnually, this.MarkedUpRevenueTotal);

    //Card
    this.CardCostPerEvalConv = this.PricingDetails.CardCostPerEval;
    this.CardCostPerCycle =
      this.PricingDetails.LengthVideoShopHours > 0 ? parseFloat(this.CardCostPerEvalConv * this.NumEvalsPerCycle) : 0;
    this.CardCostAnnually = parseFloat(this.CardCostPerCycle * this.PricingDetails.NumCyclesPerYr) || 0;
    this.CardCostPct = mathHelper.PercentageTextTwoDecimal(this.CardCostAnnually, this.MarkedUpRevenueTotal);

    //Streaming
    this.StreamingCostPerHour = mathHelper.SimplePercentageTextTwoDecimal(this.PricingDetails.StreamingCostPerHour);
    this.StreamingCostPerHourConv = this.PricingDetails.StreamingCostPerHour;
    this.StreamingCostPerEval = parseFloat(this.StreamingCostPerHourConv * this.PricingDetails.LengthVideoShopHours);
    this.StreamingCostPerCycle = parseFloat(this.StreamingCostPerEval * this.NumEvalsPerCycle);
    this.StreamingCostAnnually = parseFloat(this.StreamingCostPerCycle * this.PricingDetails.NumCyclesPerYr) || 0;
    this.StreamingCostPct = mathHelper.PercentageTextTwoDecimal(this.StreamingCostAnnually, this.MarkedUpRevenueTotal);

    //CDR
    this.CDRName = `CDR (${moneyHelper.toMoneyFormat(
      this.PricingDetails.CdrcostPerEval,
      this.PricingDetails.CurrencyCode
    )})`;
    this.IsVideoCDR = this.PricingDetails.IsVideoCdr ? 'Yes' : 'No';
    this.CDRCostPerCycle =
      this.PricingDetails.IsVideoCdr && this.PricingDetails.LengthVideoShopHours > 0
        ? parseFloat(this.PricingDetails.CdrcostPerEval * this.NumEvalsPerCycle)
        : 0;
    this.CDRCostAnnually = parseFloat(this.CDRCostPerCycle * this.PricingDetails.NumCyclesPerYr) || 0;
    this.CDRCostPct = mathHelper.PercentageTextTwoDecimal(this.CDRCostAnnually, this.MarkedUpRevenueTotal);

    //DVD
    this.DVDName = `DVD (${moneyHelper.toMoneyFormat(
      this.PricingDetails.DvdcostPerEval,
      this.PricingDetails.CurrencyCode
    )})`;
    this.IsVideoDVD = this.PricingDetails.IsVideoDvd ? 'Yes' : 'No';
    this.DVDCostPerCycle =
      this.PricingDetails.IsVideoDvd && this.PricingDetails.LengthVideoShopHours > 0
        ? parseFloat(this.PricingDetails.DVDCostPerEval * this.NumEvalsPerCycle)
        : 0;
    this.DVDCostAnnually = parseFloat(this.DVDCostPerCycle * this.PricingDetails.NumCyclesPerYr) || 0;
    this.DVDCostPct = mathHelper.PercentageTextTwoDecimal(this.DVDCostAnnually, this.MarkedUpRevenueTotal);

    //Case - Single/Double
    this.Single_Double_Name = `Case - Single (${moneyHelper.toMoneyFormat(
      this.PricingDetails.CaseCostPerEval1,
      this.PricingDetails.CurrencyCode
    )}), Double (${moneyHelper.toMoneyFormat(this.PricingDetails.CaseCostPerEval2, this.PricingDetails.CurrencyCode)})`;
    this.VideoCaseCost = this.GetVideoCaseCost(this.PricingDetails.VideoCaseTypeCode);
    this.VideoCaseCostPerCycle =
      this.PricingDetails.LengthVideoShopHours > 0 ? parseFloat(this.VideoCaseCost * this.NumEvalsPerCycle) : 0;
    this.VideoCaseCostAnnually = parseFloat(this.VideoCaseCostPerCycle * this.PricingDetails.NumCyclesPerYr) || 0;
    this.VideoCaseCostPct = mathHelper.PercentageTextTwoDecimal(this.VideoCaseCostAnnually, this.MarkedUpRevenueTotal);

    //Mailing to client (UPS)
    this.MailingCostPerEval = this.PricingDetails.MailingCostPerEval;
    this.MailingCostPerCycle =
      this.PricingDetails.LengthVideoShopHours > 0
        ? parseFloat(this.PricingDetails.MailingCostPerEval * this.NumEvalsPerCycle) || 0
        : 0;
    this.MailingCostAnnually = parseFloat(this.MailingCostPerCycle * this.PricingDetails.NumCyclesPerYr) || 0;
    this.MailingCostPct = mathHelper.PercentageTextTwoDecimal(this.MailingCostAnnually, this.MarkedUpRevenueTotal);

    //DNE
    // this.DNEPctConv = this.PricingDetails.Dnepct/100;
    // this.DNEPctConvText = mathHelper.SimplePercentageTextTwoDecimal(this.DNEPctConv);
    this.DNEPctConvText = mathHelper.SimplePercentageTextTwoDecimal(this.PricingDetails.Dnepct);
    this.DNECostPerCycle =
      this.PricingDetails.LengthVideoShopHours > 0
        ? parseFloat((this.PricingDetails.Dnepct / 100) * this.MarkedUpRevenuePerCycleTotal)
        : 0;
    this.DNECostAnnually = parseFloat(this.DNECostPerCycle * this.PricingDetails.NumCyclesPerYr) || 0;
    this.DNECostPerPct = mathHelper.PercentageTextTwoDecimal(this.DNECostAnnually, this.MarkedUpRevenueTotal);

    //TOTAL VIDEO COST
    //TOTAL OTHER COST
    this.VideoCostTotal = 0;
    if (this.VideoEditorCostAnnually >= 0) this.VideoCostTotal += this.VideoEditorCostAnnually;

    if (this.TimeCaptureCostAnnually >= 0) this.VideoCostTotal += this.TimeCaptureCostAnnually;

    if (this.ShippingCostAnnually >= 0) this.VideoCostTotal += this.ShippingCostAnnually;

    if (this.CardCostAnnually >= 0) this.VideoCostTotal += this.CardCostAnnually;

    if (this.StreamingCostAnnually >= 0) this.VideoCostTotal += this.StreamingCostAnnually;

    if (this.CDRCostAnnually >= 0) this.VideoCostTotal += this.CDRCostAnnually;

    if (this.DVDCostAnnually >= 0) this.VideoCostTotal += this.DVDCostAnnually;

    if (this.VideoCaseCostAnnually >= 0) this.VideoCostTotal += this.VideoCaseCostAnnually;

    if (this.MailingCostAnnually >= 0) this.VideoCostTotal += this.MailingCostAnnually;

    if (this.DNECostAnnually >= 0) this.VideoCostTotal += this.DNECostAnnually;

    this.VideoCostTotal = parseFloat(this.VideoCostTotal);
    this.VideoCostPct = mathHelper.PercentageTextTwoDecimal(this.VideoCostTotal, this.MarkedUpRevenueTotal);

    this.RevenuePerCycle = this.MarkedUpRevenuePerCycleTotal;
    this.RevenueAnnually = this.MarkedUpRevenueTotal;

    //DEFERRED COSTS
    this.DeferredCostPerCycle = 0;

    // const userCanMarkupValue = PricingDetailAdmin.UserCanMarkup(
    //   this.PricingDetails.OpportunityOfficeId,
    //   this.PricingDetails.OfficeId
    // );

    if (
      //(userCanMarkupValue === true || this.PricingDetails.OfficeId === this.PricingDetails.OpportunityOfficeId) &&
      this.PricingDetails.OwningOfficeIsEditing === true
    ) {
      this.DeferredCostPerCycle += this.PricingDetails.EditorCostPerCycle;
    }

    if (
      //(userCanMarkupValue === true || this.PricingDetails.OfficeId === this.PricingDetails.OpportunityOfficeId) &&
      this.PricingDetails.OwningOfficeIsTranslating === true
    ) {
      this.DeferredCostPerCycle += this.PricingDetails.TransCostPerCycle;
    }

    if (
      //(userCanMarkupValue === true || this.PricingDetails.OfficeId === this.PricingDetails.OpportunityOfficeId) &&
      this.PricingDetails.OwningOfficeIsChecking === true
    ) {
      this.DeferredCostPerCycle += this.PricingDetails.ExtDataCheckPerCycle;
    }

    //if (userCanMarkupValue === true || this.PricingDetails.OfficeId === this.PricingDetails.OpportunityOfficeId) {
    this.DeferredCostPerCycle += this.CommissionPerCycle;
    //}

    if (this.StatusCode === 2 || [1, 2, 3, 6, 9].includes(this.PricingDetails.ServiceTypeCode)) {
      this.DeferredCostPerCycle += this.VocazillaCostPerCycle;
    }

    if (this.StatusCode === 2 || this.PricingDetails.ServiceTypeCode === 10) {
      this.DeferredCostPerCycle += this.IVRFeeCostAnnually;
    }

    if (this.StatusCode === 2 || this.PricingDetails.ServiceTypeCode === 7) {
      this.DeferredCostPerCycle += this.ICRFeeCostPerCycle;
    }

    if (this.PricingDetails.ServiceTypeCode !== 7 && this.PricingDetails.ServiceTypeCode !== 10) {
      this.DeferredCostPerCycle += this.SMCostPerCycle;
    }

    this.DeferredCostAnnually = this.DeferredCostPerCycle * this.PricingDetails.NumCyclesPerYr;

    //Owning Office Cost Per Cycle
    this.CostPerCycle = this.ClientFeePerCycleTotal + this.DeferredCostPerCycle;

    //Owning Office Total Cost
    this.CostAnnually = this.ClientRevenueTotal + this.DeferredCostAnnually;

    this.DeferredCostAnnuallyPct = mathHelper.PercentageText(this.DeferredCostAnnually, this.CostAnnually);
    this.DeferredCostAnnuallyMarkedUpRevenueTotalPct = mathHelper.PercentageText(
      this.DeferredCostAnnually,
      this.MarkedUpRevenueTotal
    );

    this.CostAnnuallyMarkedUpRevenueTotalPct = mathHelper.PercentageText(this.CostAnnually, this.MarkedUpRevenueTotal);

    this.ClientRevenueTotalCostAnnually = mathHelper.PercentageText(this.ClientRevenueTotal, this.CostAnnually);
    this.ClientRevenueTotalMarkedUpRevenueTotalPct = mathHelper.PercentageText(
      this.ClientRevenueTotal,
      this.MarkedUpRevenueTotal
    );

    //FW Office Total Cost
    this.CostSum =
      this.EvalFeeAnnually +
      this.TravelCostAnnuallyTotal +
      this.RecruitingCostTotal +
      this.EditingCostTotal +
      this.EmployeeCostTotal +
      this.OtherCostTotal +
      this.VideoCostTotal;

    //Fieldwork office cost and fieldwork office net revenue was calculated incorrectly because of this
    //If for some reason other calculations work incorrectly, consider another solution
    //Check this pricing detail to test if solution works in both cases: 71639
    // if (userCanMarkupValue) {
    //   this.CostSum = this.CostAnnually;
    // }

    this.FieldworkOfficeCostPerCycle =
      (this.PricingDetails.NumCyclesPerYr === 0 ? 0 : this.CostSum / this.PricingDetails.NumCyclesPerYr) -
      this.DeferredCostPerCycle;

    this.FieldworkOfficeCostAnnually = parseFloat(this.CostSum - this.DeferredCostAnnually);

    this.FieldworkOfficeCostAnnuallyCostAnnuallyPtc = mathHelper.PercentageText(
      this.FieldworkOfficeCostAnnually,
      this.CostAnnually
    );
    this.FieldworkOfficeMarkedUpRevenueTotalPtc = mathHelper.PercentageText(
      this.FieldworkOfficeCostAnnually,
      this.MarkedUpRevenueTotal
    );

    this.FieldworkOfficeNetRevenuePerCycle = this.ClientFeePerCycleTotal - this.FieldworkOfficeCostPerCycle;
    this.FieldworkOfficeNetRevenueAnnually = this.ClientRevenueTotal - this.FieldworkOfficeCostAnnually;

    this.FieldworkOfficeNetRevenueOfCost = mathHelper.PercentageText(
      this.FieldworkOfficeNetRevenueAnnually,
      this.CostAnnually
    );
    this.FieldworkOfficeNetRevenueOfRevenue = mathHelper.PercentageText(
      this.FieldworkOfficeNetRevenueAnnually,
      this.MarkedUpRevenueTotal
    );

    this.OwningOfficeNetRevenuePerCycle = parseFloat(this.RevenuePerCycle - this.CostPerCycle);
    this.OwningOfficeNetRevenueAnnually = parseFloat(this.RevenueAnnually - this.CostAnnually);
    this.OwningOfficeNetRevenueOfRevenue = mathHelper.PercentageText(
      this.OwningOfficeNetRevenueAnnually,
      this.MarkedUpRevenueTotal
    );

    //Depending on if there is a fieldwork office, we consider different costs
    this.TotalCosts =
      this.PricingDetails.OfficeId === this.PricingDetails.OpportunityOfficeId ? this.CostSum : this.CostAnnually;

    this.RevenueTotal = moneyHelper.toMoneyFormat(this.MarkedUpRevenueTotal, this.PricingDetails.CurrencyCode);
    this.CostTotal = moneyHelper.toMoneyFormat(this.TotalCosts, this.PricingDetails.CurrencyCode);
    this.CostPct = mathHelper.PercentageText(this.TotalCosts, this.MarkedUpRevenueTotal);

    this.NetRevenueTotal = moneyHelper.toMoneyFormat(
      this.MarkedUpRevenueTotal - this.TotalCosts,
      this.PricingDetails.CurrencyCode
    );
    this.RevenuePct = mathHelper.PercentageText(this.MarkedUpRevenueTotal - this.TotalCosts, this.MarkedUpRevenueTotal);
    this.CurrencyCode = this.PricingDetails.CurrencyCode;

    //FW calculations added in CD-3973
    this.RevenueFWTotal = moneyHelper.toMoneyFormat(
      mathHelper.ConvertToTwoDecimalNumber(this.ClientRevenueTotal),
      this.CurrencyCode
    );

    this.CostFWTotal = moneyHelper.toMoneyFormat(
      mathHelper.ConvertToTwoDecimalNumber(this.FieldworkOfficeCostAnnually),
      this.CurrencyCode
    );
    this.CostFWPct = mathHelper.PercentageText(this.FieldworkOfficeCostAnnually, this.ClientRevenueTotal);

    this.NetRevenueFWTotal = moneyHelper.toMoneyFormat(
      mathHelper.ConvertToTwoDecimalNumber(this.FieldworkOfficeNetRevenueAnnually),
      this.CurrencyCode
    );
    this.NetRevenueFWPct = mathHelper.PercentageText(this.FieldworkOfficeNetRevenueAnnually, this.ClientRevenueTotal);
  }

  // UserCanMarkup() {
  //   return true;
  // }

  // CheckIfSameOffice() {
  //   return this.PricingDetails.OfficeId === this.PricingDetails.OpportunityOfficeId;
  // }

  GetVideoCaseCost(value) {
    value = parseInt(value);
    if (value === '0.00') return 0;
    if (value === 1) return this.PricingDetails.CaseCostPerEval1;
    if (value === 2) return this.PricingDetails.CaseCostPerEval2;
    return 0;
  }

  validate(value) {
    return value !== null && value !== '';
  }
}

export default TierItemList;
